export const LOCALIZATION_EVENTS = {
  init: 'localization/init',
  set: 'localization/set',
  load: 'localization/load',
  failure: 'localization/failure',
} as const;

export const LOCALIZATION_STORE_NAME = 'localization' as const;
